import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Alert,
    AppBar,
    Box,
    Button,
    Checkbox,
    Container,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    MenuItem,
    Modal,
    Select as MuiSelect,
    Radio,
    RadioGroup,
    Snackbar,
    Stack,
    Tab,
    Tabs,
    TextField,
    Toolbar,
    Typography,
} from '@mui/material';
import { default as React, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { REQUIRED_RED } from '../../../App';
import { getCityList, getProvinceList } from '../../../redux/Customer/action';
import { CONTACT_PREFRENCES_SUPPLERS, PHONE_TYPES } from '../../../utility/Constant';
import { customStyles, errorCustomStyles, phoneTypeCustomStyles } from '../../../utility/SelectDropdown';
import { cleanPhoneNumber, inputFormatPhoneNumber, removeDashFromPhoneNumber } from '../../Common/FormatPhoneNumber';
// import "../Customers.css";
import AddressSelect from '../../Customers/Profile/AddressSelect';

import { useSelector } from 'react-redux';
import PostalCode from '../../../components/Address/PostalCode';
import { formatPostalCode, preventPhoneInputKeys } from '../../../components/FormatNumber/FormatNumber';
import { getCountryMasterListApi } from '../../../redux/Account/peronalIfno/action';
import { filterUndefined } from '../../../utility/helpers/commonFunction';
import AddressAutocomplete from '../../Customers/Profile/AddressAutocomplete';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: '2px solid ',
    boxShadow: 24,
    // p: 3,
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function SupplierEditModal({ openEditSupplier, handleCloseSupplier, onSubmitSupplier, setOpenDelete, type, addressValues, setAddressValues }) {
    const dispatch = useDispatch();
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue: setValueinForm,
        setError,
        clearErrors,
        getValues,
    } = useForm();

    const [editModalTabvalue, setEditModalTabValue] = useState(0);
    const [phoneTypes, setPhoneTypes] = useState(PHONE_TYPES);
    const [contactPrefrences, setContactPrefrences] = useState(CONTACT_PREFRENCES_SUPPLERS);
    const [showSecondaryNumber, setShowSecondaryNumber] = useState(false);
    const [selectedPhoneTypes, setSelectedPhoneTypes] = useState({
        primary: 'mobile',
        secondary: 'mobile',
    });
    const [getAddress, setAddress] = useState();
    const [country, setCountry] = useState();
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [showSecondaryEmail, setShowSecondaryEmail] = useState(false);
    const [contactPrefrenceValue, setContactPrefrenceValue] = useState('');
    const handleChangeEditCustomerTabValue = (event, newValue) => {
        setEditModalTabValue(newValue);
    };
    const [cityList, setCityList] = useState([]);
    const [provinceList, setProvinceList] = useState([]);
    const [cityListLoader, setCityListLoader] = useState(false);
    const [provinceListLoader, setProvinceListLoader] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');

    //
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCountrySecondary, setSelectedCountrySecondary] = useState(null);

    const countryMasterList = useSelector((state) => state.account?.countryMasterList);

    useEffect(() => {
        fetchCityList();
        fetchProvinceList();
        fetchCountryMasterList();
    }, []);

    const fetchCountryMasterList = async () => {
        await dispatch(getCountryMasterListApi());
    };

    const fetchCityList = async (province, country) => {
        setCityListLoader(true);
        let resp = await dispatch(getCityList({ country: '64e738882fec8f2c9b79c139', province: province }));
        if (resp) {
            setCityList(resp);
        }
        setCityListLoader(false);
    };

    const fetchProvinceList = async (country) => {
        setProvinceListLoader(true);
        let resp = await dispatch(getProvinceList({ country: '64e738882fec8f2c9b79c139' }));
        if (resp) {
            setProvinceList(resp);
        }
        setProvinceListLoader(false);
    };

    const supplierDetails = useSelector((state) => state.supplier.supplierDetail);
    console.log('🚀 ~ supplierDetails:', supplierDetails);

    useEffect(() => {
        reset();
        setShowSecondaryNumber(false);
        setShowSecondaryEmail(false);
        console.log('supplierDetails', supplierDetails);

        setValueinForm('name', supplierDetails?.name);
        setValueinForm('account', supplierDetails?.account);

        if (supplierDetails?.phoneNumberType) {
            setValueinForm(
                'phoneNumberType',
                supplierDetails.phoneNumberType ? phoneTypes.find((option) => option.key === supplierDetails?.phoneNumberType) : ''
            );
            setSelectedPhoneTypes({
                ...selectedPhoneTypes,
                primary: supplierDetails?.phoneNumberType,
            });
        } else {
            setValueinForm('phoneNumberType', selectedPhoneTypes ? phoneTypes.find((option) => option.key === selectedPhoneTypes?.primary) : '');
            setSelectedPhoneTypes({
                ...selectedPhoneTypes,
                primary: supplierDetails?.phoneNumberType,
            });
        }
        //Select Phone Number country
        if (supplierDetails?.phoneNumberCountry?._id) {
            const selected = countryMasterList.find((item) => item._id === supplierDetails?.phoneNumberCountry?._id);
            setSelectedCountry(selected);
        } else {
            const selected = countryMasterList.find((item) => item.default === true);
            setSelectedCountry(selected);
        }

        if (supplierDetails?.secondaryPhoneNumberType) {
            setValueinForm(
                'secondaryPhoneNumberType',
                supplierDetails.secondaryPhoneNumberType ? phoneTypes.find((option) => option.key === supplierDetails?.secondaryPhoneNumberType) : ''
            );
            setSelectedPhoneTypes({
                ...selectedPhoneTypes,
                secondary: supplierDetails?.secondaryPhoneNumberType,
            });
        } else {
            setValueinForm('secondaryPhoneNumberType', selectedPhoneTypes ? phoneTypes.find((option) => option.key === selectedPhoneTypes?.secondary) : '');
            setSelectedPhoneTypes({
                ...selectedPhoneTypes,
                secondary: supplierDetails?.secondaryPhoneNumberType,
            });
        }

        //Select Phone NUmber Country 2
        if (supplierDetails?.secondaryPhoneNumberCountry?._id) {
            const selected = countryMasterList.find((item) => item._id === supplierDetails?.secondaryPhoneNumberCountry?._id);
            setSelectedCountrySecondary(selected);
        } else {
            const selected = countryMasterList.find((item) => item.default === true);
            setSelectedCountrySecondary(selected);
        }

        setValueinForm('contactPerson.firstName', supplierDetails?.contactPerson?.firstName);
        setValueinForm('contactPerson.lastName', supplierDetails?.contactPerson?.lastName);
        setValueinForm('phoneNumber', inputFormatPhoneNumber(supplierDetails?.phoneNumber));
        if (supplierDetails?.secondaryPhoneNumber) {
            setValueinForm('secondaryPhoneNumber', inputFormatPhoneNumber(supplierDetails?.secondaryPhoneNumber));
        }
        setValueinForm('primaryEmail', supplierDetails?.primaryEmail);
        setValueinForm('website', supplierDetails?.website);
        setValueinForm('contactPreference', supplierDetails?.contactPreference);
        setContactPrefrenceValue(supplierDetails?.contactPreference);
        setValueinForm('streetAddress', supplierDetails?.streetAddress);
        setValueinForm('city', supplierDetails?.city?._id);
        setValueinForm('province', supplierDetails?.province?._id);
        setValueinForm('postalCode', supplierDetails?.postalCode);
        setValueinForm('country', supplierDetails?.country?.country);
        setAddress(supplierDetails?.streetAddress);
        setAddressValues({
            ...addressValues,
            city: supplierDetails?.city?.city,
            province: supplierDetails?.province?.province,
            cityId: supplierDetails?.city?._id,
            provinceId: supplierDetails?.province?._id,
            streetAddress: supplierDetails?.streetAddress,
            postal: formatPostalCode(supplierDetails?.postalCode),
        });
        setCountry(supplierDetails?.country?.country);

        if (supplierDetails?.secondaryPhoneNumber && supplierDetails?.secondaryPhoneNumber !== '') {
            setShowSecondaryNumber(true);
            setValueinForm(
                'secondaryPhoneNumberType',
                supplierDetails.secondaryPhoneNumberType ? phoneTypes.find((option) => option.key === supplierDetails?.secondaryPhoneNumberType) : ''
            );
            setSelectedPhoneTypes({
                ...selectedPhoneTypes,
                secondary: supplierDetails?.secondaryPhoneNumberType,
            });
        }
        if (supplierDetails?.secondaryEmail) {
            setShowSecondaryEmail(true);
            setValueinForm('secondaryEmail', supplierDetails.secondaryEmail);
        }
    }, [supplierDetails]);

    const handleUpdate = (values) => {
        console.log('🚀 ~ handleUpdate ~ values:', values);
        const { streetAddress, city, province, postalCode } = values;

        const isAnyFieldFilled = [streetAddress, city, province, postalCode].some((field) => field && field.trim() !== '');
        if (isAnyFieldFilled) {
            if (!streetAddress)
                setError('streetAddress', {
                    type: 'required',
                    message: 'Street address is required',
                });
            if (!city) setError('city', { type: 'required', message: 'City is required' });
            if (!province)
                setError('province', {
                    type: 'required',
                    message: 'Province is required',
                });
            if (!postalCode) {
                setError('postalCode', {
                    type: 'required',
                    message: 'Postal code is required',
                });
            } else {
                const isUSA = selectedCountry?.country === 'United States';
                const isValidLength = isUSA ? postalCode.length === 5 : postalCode.length === 7;

                if (!isValidLength) {
                    const errorMessage = isUSA ? 'Postal code is required - 5 digits' : 'Postal code is required - 6 digits';
                    setError('postalCode', {
                        type: 'required',
                        message: errorMessage,
                    });
                    setEditModalTabValue(1);
                    return;
                }
            }

            if (!streetAddress || !city || !province || !postalCode) {
                setEditModalTabValue(1);
                return;
            }
        } else {
            clearErrors();
        }
        let payload = { ...values };

        payload.cityId = values?.city;
        payload.provinceId = values?.province;

        // Phone number handling
        payload.phoneNumberType = payload.phoneNumberType?.key;
        // payload.countryCode = selectedCountry?.dial_code;
        payload.phoneNumberCountryId = selectedCountry?._id;
        payload.phoneNumber = cleanPhoneNumber(payload.phoneNumber);

        if (payload.secondaryPhoneNumber) {
            payload.secondaryPhoneNumberType = payload.secondaryPhoneNumberType?.key;
            // payload.secondaryPhoneNumberCountryCode =
            //   selectedCountrySecondary?.dial_code;
            payload.secondaryPhoneNumberCountryId = selectedCountrySecondary?._id;
            payload.secondaryPhoneNumber = cleanPhoneNumber(payload.secondaryPhoneNumber);
        } else {
            delete payload.secondaryPhoneNumberType;
        }

        // Email handling based on primaryEmailIndex
        if (primaryEmailIndex === 0) {
            payload.primaryEmail = values.primaryEmail;
            payload.secondaryEmail = values.secondaryEmail || undefined;
        } else if (primaryEmailIndex === 1) {
            payload.primaryEmail = values.secondaryEmail;
            payload.secondaryEmail = values.primaryEmail;
        }
        setPrimaryEmailIndex(0);
        onSubmitSupplier(filterUndefined(payload));
    };

    //Change Country Function
    const handleCountryChange = (event) => {
        const selected = countryMasterList.find((item) => item._id === event.target.value);
        setSelectedCountry(selected);
    };

    const handleCountryChangeSecondary = (event) => {
        const selected = countryMasterList.find((item) => item._id === event.target.value);
        setSelectedCountrySecondary(selected);
    };

    return (
        <div>
            <Modal
                open={openEditSupplier}
                onClose={() => {
                    handleCloseSupplier();
                }}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box
                    sx={{
                        ...style,
                        border: 'none',
                        borderRadius: '8px 8px 0px 0px',
                    }}
                    className="modalBodyBoxContainer"
                >
                    <AppBar
                        color="secondary"
                        variant="elevation"
                        sx={{
                            backgroundColor: '#002394',
                            color: 'white',
                            height: '64px',
                            borderRadius: '8px 8px 0px 0px !important',
                            paddingRight: '0px !important',
                        }}
                    >
                        <Toolbar variant="regular">
                            <Typography variant="h6" width={'98%'} color={'white'}>
                                Edit Supplier
                            </Typography>
                            <Stack direction={'row'} spacing={0}>
                                <div
                                    onClick={() => {
                                        handleCloseSupplier();
                                    }}
                                    style={{ cursor: 'pointer', height: '32px' }}
                                >
                                    <CloseIcon style={{ color: '#0000008F', fontSize: 32 }} />
                                </div>
                            </Stack>
                        </Toolbar>
                    </AppBar>
                    <Container
                        gap={2}
                        disableGutters
                        style={{
                            marginTop: '66px',
                            // scrollbarColor: "blue",
                            // scrollbarWidth: "thin",
                            // overflowY: "auto",
                            // maxHeight: "80vh",
                            // position: "relative",
                        }}
                    >
                        <form onSubmit={handleSubmit(handleUpdate)}>
                            <Grid
                                container
                                // spacing={3}
                                style={{
                                    scrollbarColor: 'blue',
                                    scrollbarWidth: 'thin',
                                    overflowY: 'auto',
                                    maxHeight: '70vh',
                                }}
                                padding={'24px 24px 0 24px'}
                            >
                                <Tabs
                                    value={editModalTabvalue}
                                    onChange={handleChangeEditCustomerTabValue}
                                    aria-label="basic tabs example"
                                    sx={{ marginBottom: '24px' }}
                                >
                                    <Tab label="BASIC DETAILS" {...a11yProps(0)} />

                                    <Tab label="ADDITIONAL DETAILS" {...a11yProps(1)} />
                                </Tabs>

                                <div style={{ display: editModalTabvalue == 0 ? 'block' : 'none' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6} xl={6}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Supplier Name <span style={{ color: '#D32F2F' }}> *</span>
                                                </Typography>
                                                <Controller
                                                    name="name"
                                                    control={control}
                                                    rules={{
                                                        required: 'Supplier name is required',
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            // required
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            error={!!errors.name}
                                                            helperText={errors.name ? errors.name.message : ''}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={6}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Account #
                                                </Typography>
                                                <Controller
                                                    name="account"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            fullWidth
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            error={!!errors.account}
                                                            helperText={errors.account ? errors.account.message : ''}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={6}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Contact First Name{' '}
                                                </Typography>
                                                <Controller
                                                    name="contactPerson.firstName"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            error={!!errors.firstName}
                                                            helperText={errors.firstName ? errors.firstName.message : ''}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={6}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Contact Last Name
                                                </Typography>
                                                <Controller
                                                    name="contactPerson.lastName"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            fullWidth
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            error={!!errors.lastName}
                                                            helperText={errors.lastName ? errors.lastName.message : ''}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item container xs={12} sm={12} md={12} xl={12}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Stack spacing={1}>
                                                    <Typography
                                                        variant="body1"
                                                        style={{
                                                            fontWeight: 500,
                                                            fontSize: '16px',
                                                            lineHeight: '24px',
                                                            letterSpacing: '0.15px',
                                                        }}
                                                    >
                                                        {' '}
                                                        Primary Phone Number <span style={{ color: REQUIRED_RED }}>*</span>
                                                    </Typography>
                                                    <div style={{ display: 'flex' }}>
                                                        <Grid container spacing={2} rowGap={2}>
                                                            <Grid item xs={12} sm={12} md={8} lg={3} xl={3}>
                                                                <FormControl fullWidth error={!!errors.phoneNumberType}>
                                                                    <Controller
                                                                        name="phoneNumberType"
                                                                        control={control}
                                                                        rules={{
                                                                            required: 'Phone Number Type is required',
                                                                        }}
                                                                        render={({ field }) => (
                                                                            <Select
                                                                                placeholder="" // defaultValue={}
                                                                                isLoading={false}
                                                                                isClearable={false}
                                                                                isSearchable={false}
                                                                                value={
                                                                                    selectedPhoneTypes
                                                                                        ? phoneTypes.find((option) => option.key == selectedPhoneTypes?.primary)
                                                                                        : ''
                                                                                }
                                                                                options={phoneTypes ? phoneTypes : []}
                                                                                getOptionLabel={(option) => option.value} // Specifies which field to use as the label
                                                                                getOptionValue={(option) => option.key}
                                                                                onChange={(e) => {
                                                                                    setSelectedPhoneTypes({
                                                                                        ...selectedPhoneTypes,
                                                                                        primary: e ? e.key : '',
                                                                                    });
                                                                                }}
                                                                                styles={
                                                                                    errors.phoneNumberType
                                                                                        ? {
                                                                                              ...customStyles,
                                                                                              ...errorCustomStyles,
                                                                                              ...phoneTypeCustomStyles,
                                                                                          }
                                                                                        : {
                                                                                              ...customStyles,
                                                                                              ...phoneTypeCustomStyles,
                                                                                          }
                                                                                }
                                                                                error={!!errors.phoneNumberType}
                                                                                helperText={errors.phoneNumberType ? errors.phoneNumberType.message : ''}
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {errors.phoneNumberType && (
                                                                        <FormHelperText>{errors.phoneNumberType.message}</FormHelperText>
                                                                    )}
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                                                                <Controller
                                                                    name="phoneNumber"
                                                                    control={control}
                                                                    rules={{
                                                                        required: 'Phone Number is required',
                                                                        pattern: {
                                                                            value: /^\d{3}-\d{3}-\d{4}$/,
                                                                            message: 'Phone number should be 10 digits long',
                                                                        },
                                                                    }}
                                                                    render={({ field }) => (
                                                                        <TextField
                                                                            InputProps={{
                                                                                startAdornment: (
                                                                                    <MuiSelect
                                                                                        style={{
                                                                                            width: '92px',
                                                                                            minWidth: '92px',
                                                                                            height: '56px',
                                                                                            border: 'none',
                                                                                            marginRight: '16.5px',
                                                                                        }}
                                                                                        MenuProps={{
                                                                                            PaperProps: {
                                                                                                style: {
                                                                                                    width: '264px',
                                                                                                    marginLeft: '86px',
                                                                                                    boxShadow:
                                                                                                        'box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                                },
                                                                                            },
                                                                                            MenuListProps: {
                                                                                                style: {},
                                                                                            },
                                                                                        }}
                                                                                        sx={{
                                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                                borderRight: 'none',
                                                                                            },
                                                                                            '& .MuiOutlinedInput-root': {
                                                                                                borderTopRightRadius: '0px',
                                                                                                borderBottomRightRadius: '0px',
                                                                                            },
                                                                                            borderTopRightRadius: '0px',
                                                                                            borderBottomRightRadius: '0px',
                                                                                            background: '#F1F1F1',
                                                                                        }}
                                                                                        value={selectedCountry?._id ?? ''}
                                                                                        onChange={handleCountryChange}
                                                                                        renderValue={(selected) => {
                                                                                            const country =
                                                                                                countryMasterList.find((item) => item._id === selected) ||
                                                                                                selectedCountry;
                                                                                            if (!country) return 'Select';
                                                                                            return (
                                                                                                <div
                                                                                                    style={{
                                                                                                        display: 'flex',
                                                                                                        alignItems: 'center',
                                                                                                    }}
                                                                                                >
                                                                                                    <span
                                                                                                        style={{
                                                                                                            marginRight: '8px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            src={country?.flag_svg}
                                                                                                            alt="flag"
                                                                                                            style={{
                                                                                                                width: '24px',
                                                                                                                height: '12px',
                                                                                                            }}
                                                                                                        />
                                                                                                    </span>
                                                                                                    {country.dial_code}
                                                                                                </div>
                                                                                            );
                                                                                        }}
                                                                                        IconComponent={KeyboardArrowDownIcon}
                                                                                    >
                                                                                        {countryMasterList?.length > 0 &&
                                                                                            countryMasterList.map((country) => (
                                                                                                <MenuItem
                                                                                                    key={country._id}
                                                                                                    value={country._id}
                                                                                                    style={{ height: '44px' }}
                                                                                                >
                                                                                                    <span
                                                                                                        style={{
                                                                                                            marginRight: '8px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            src={country?.flag_svg}
                                                                                                            alt="flag"
                                                                                                            style={{
                                                                                                                width: '24px',
                                                                                                                height: '12px',
                                                                                                            }}
                                                                                                        />
                                                                                                    </span>
                                                                                                    {country.country} ({country.dial_code})
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                    </MuiSelect>
                                                                                ),
                                                                            }}
                                                                            id="outlined-basic"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    paddingLeft: '0',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            // required

                                                                            error={!!errors.phoneNumber}
                                                                            helperText={errors.phoneNumber ? errors.phoneNumber.message : ''}
                                                                            {...field}
                                                                            onChange={(e) => {
                                                                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                                                                    const input = e.target;
                                                                                    const rawValue = e.target.value;
                                                                                    // Store previous cursor position
                                                                                    const prevCursorPosition = input.selectionStart;
                                                                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                                                                    // Count hyphens before formatting
                                                                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                                                                    // Format the input value
                                                                                    const formattedValue = inputFormatPhoneNumber(rawValue);

                                                                                    // Count hyphens after formatting
                                                                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                                                                    let newCursorPosition = prevCursorPosition;

                                                                                    if (isDeleting) {
                                                                                        // If a hyphen was removed, move cursor back by 1
                                                                                        if (hyphenCountAfter < hyphenCountBefore) {
                                                                                            newCursorPosition--;
                                                                                        }
                                                                                    } else {
                                                                                        // If a hyphen was added, move cursor forward by 1
                                                                                        if (hyphenCountAfter > hyphenCountBefore) {
                                                                                            newCursorPosition++;
                                                                                        }
                                                                                    }
                                                                                    // Ensure cursor position doesn't go out of bounds
                                                                                    newCursorPosition = Math.max(
                                                                                        0,
                                                                                        Math.min(newCursorPosition, formattedValue.length)
                                                                                    );
                                                                                    // Update the state
                                                                                    setValueinForm('phoneNumber', formattedValue);

                                                                                    // Restore the adjusted cursor position
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                                                                    }, 0);

                                                                                    if (removeDashFromPhoneNumber(e.target.value).length < 10) {
                                                                                        setError('phoneNumber', {
                                                                                            message: 'Phone Number should be 10 digits',
                                                                                        });
                                                                                    } else clearErrors('phoneNumber');
                                                                                }
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                preventPhoneInputKeys(e);
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </Stack>
                                                {!showSecondaryNumber && (
                                                    <div
                                                        onClick={() => setShowSecondaryNumber(true)}
                                                        style={{
                                                            color: '#006CDD',
                                                            cursor: 'pointer',
                                                            fontWeight: 500,
                                                            height: '36px',
                                                            padding: '4px 5px',
                                                            letterSpacing: '0.46px',
                                                            fontSize: '14px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        + ADD PHONE NUMBER
                                                    </div>
                                                )}
                                            </Grid>
                                        </Grid>
                                        {showSecondaryNumber && (
                                            <Grid item container xs={12} sm={12} md={12} xl={12}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Stack spacing={1}>
                                                        <Typography
                                                            variant="body1"
                                                            style={{
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '24px',
                                                                letterSpacing: '0.15px',
                                                            }}
                                                        >
                                                            {' '}
                                                            Secondary Phone Number{' '}
                                                        </Typography>
                                                        <div style={{ display: 'flex' }}>
                                                            <Grid container spacing={2} rowGap={2}>
                                                                <Grid item xs={12} sm={12} md={8} lg={3} xl={3}>
                                                                    <FormControl fullWidth error={!!errors.secondaryPhoneNumberType}>
                                                                        <Controller
                                                                            name="secondaryPhoneNumberType"
                                                                            control={control}
                                                                            render={({ field }) => (
                                                                                <Select
                                                                                    placeholder="" // defaultValue={}
                                                                                    isLoading={false}
                                                                                    isClearable={false}
                                                                                    isSearchable={false}
                                                                                    value={
                                                                                        selectedPhoneTypes
                                                                                            ? phoneTypes.find(
                                                                                                  (option) => option.key === selectedPhoneTypes?.secondary
                                                                                              )
                                                                                            : ''
                                                                                    }
                                                                                    options={phoneTypes ? phoneTypes : []}
                                                                                    getOptionLabel={(option) => option.value} // Specifies which field to use as the label
                                                                                    getOptionValue={(option) => option}
                                                                                    onChange={(e) => {
                                                                                        setSelectedPhoneTypes({
                                                                                            ...selectedPhoneTypes,
                                                                                            secondary: e ? e.key : '',
                                                                                        });
                                                                                    }}
                                                                                    styles={
                                                                                        errors.secondaryPhoneNumberType
                                                                                            ? {
                                                                                                  ...customStyles,
                                                                                                  ...errorCustomStyles,
                                                                                                  ...phoneTypeCustomStyles,
                                                                                              }
                                                                                            : {
                                                                                                  ...customStyles,
                                                                                                  ...phoneTypeCustomStyles,
                                                                                              }
                                                                                    }
                                                                                    error={!!errors.secondaryPhoneNumberType}
                                                                                    helperText={
                                                                                        errors.secondaryPhoneNumberType
                                                                                            ? errors.secondaryPhoneNumberType.message
                                                                                            : ''
                                                                                    }
                                                                                    {...field}
                                                                                />
                                                                            )}
                                                                        />
                                                                        {errors.secondaryPhoneNumberType && (
                                                                            <FormHelperText>{errors.secondaryPhoneNumberType.message}</FormHelperText>
                                                                        )}
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                                                    <Controller
                                                                        name="secondaryPhoneNumber"
                                                                        control={control}
                                                                        rules={{
                                                                            pattern: {
                                                                                value: /^\d{3}-\d{3}-\d{4}$/,
                                                                                message: 'Phone number should be 10 digits long',
                                                                            },
                                                                        }}
                                                                        render={({ field }) => (
                                                                            <TextField
                                                                                InputProps={{
                                                                                    startAdornment: (
                                                                                        <MuiSelect
                                                                                            MenuProps={{
                                                                                                PaperProps: {
                                                                                                    style: {
                                                                                                        width: '264px',
                                                                                                        marginLeft: '86px',
                                                                                                        boxShadow:
                                                                                                            'box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                                    },
                                                                                                },
                                                                                                MenuListProps: {
                                                                                                    style: {},
                                                                                                },
                                                                                            }}
                                                                                            style={{
                                                                                                width: '92px',
                                                                                                minWidth: '92px',
                                                                                                height: '56px',
                                                                                                border: 'none',
                                                                                                marginRight: '16.5px',
                                                                                            }}
                                                                                            sx={{
                                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                                    borderRight: 'none',
                                                                                                },
                                                                                                '& .MuiOutlinedInput-root': {
                                                                                                    borderTopRightRadius: '0px',
                                                                                                    borderBottomRightRadius: '0px',
                                                                                                },
                                                                                                borderTopRightRadius: '0px',
                                                                                                borderBottomRightRadius: '0px',
                                                                                                background: '#F1F1F1',
                                                                                            }}
                                                                                            value={selectedCountrySecondary?._id ?? ''}
                                                                                            onChange={handleCountryChangeSecondary}
                                                                                            renderValue={(selected) => {
                                                                                                const country =
                                                                                                    countryMasterList.find((item) => item._id === selected) ||
                                                                                                    selectedCountrySecondary;
                                                                                                if (!country) return 'Select';
                                                                                                return (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                        }}
                                                                                                    >
                                                                                                        <span
                                                                                                            style={{
                                                                                                                marginRight: '8px',
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={country?.flag_svg}
                                                                                                                alt="flag"
                                                                                                                style={{
                                                                                                                    width: '24px',
                                                                                                                    height: '12px',
                                                                                                                }}
                                                                                                            />
                                                                                                        </span>
                                                                                                        {country.dial_code}
                                                                                                    </div>
                                                                                                );
                                                                                            }}
                                                                                            IconComponent={KeyboardArrowDownIcon}
                                                                                        >
                                                                                            {countryMasterList?.length > 0 &&
                                                                                                countryMasterList.map((country) => (
                                                                                                    <MenuItem
                                                                                                        key={country._id}
                                                                                                        value={country._id}
                                                                                                        style={{ height: '44px' }}
                                                                                                    >
                                                                                                        <span
                                                                                                            style={{
                                                                                                                marginRight: '8px',
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={country?.flag_svg}
                                                                                                                alt="flag"
                                                                                                                style={{
                                                                                                                    width: '24px',
                                                                                                                    height: '12px',
                                                                                                                }}
                                                                                                            />
                                                                                                        </span>
                                                                                                        {country.country} ({country.dial_code})
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                        </MuiSelect>
                                                                                    ),
                                                                                }}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        paddingLeft: '0',
                                                                                    },
                                                                                }}
                                                                                id="outlined-basic"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                // required
                                                                                error={!!errors.secondaryPhoneNumber}
                                                                                helperText={
                                                                                    errors.secondaryPhoneNumber ? errors.secondaryPhoneNumber.message : ''
                                                                                }
                                                                                {...field}
                                                                                onChange={(e) => {
                                                                                    if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                                                                        const input = e.target;
                                                                                        const rawValue = e.target.value;
                                                                                        // Store previous cursor position
                                                                                        const prevCursorPosition = input.selectionStart;
                                                                                        const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                                                                        // Count hyphens before formatting
                                                                                        const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                                                                        // Format the input value
                                                                                        const formattedValue = inputFormatPhoneNumber(rawValue);

                                                                                        // Count hyphens after formatting
                                                                                        const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                                                                        let newCursorPosition = prevCursorPosition;

                                                                                        if (isDeleting) {
                                                                                            // If a hyphen was removed, move cursor back by 1
                                                                                            if (hyphenCountAfter < hyphenCountBefore) {
                                                                                                newCursorPosition--;
                                                                                            }
                                                                                        } else {
                                                                                            // If a hyphen was added, move cursor forward by 1
                                                                                            if (hyphenCountAfter > hyphenCountBefore) {
                                                                                                newCursorPosition++;
                                                                                            }
                                                                                        }
                                                                                        // Ensure cursor position doesn't go out of bounds
                                                                                        newCursorPosition = Math.max(
                                                                                            0,
                                                                                            Math.min(newCursorPosition, formattedValue.length)
                                                                                        );
                                                                                        // Update the state
                                                                                        setValueinForm('secondaryPhoneNumber', formattedValue);

                                                                                        // Restore the adjusted cursor position
                                                                                        setTimeout(() => {
                                                                                            input.setSelectionRange(newCursorPosition, newCursorPosition);
                                                                                        }, 0);

                                                                                        if (removeDashFromPhoneNumber(e.target.value).length < 10) {
                                                                                            setError('secondaryPhoneNumber', {
                                                                                                message: 'Phone Number should be 10 digits',
                                                                                            });
                                                                                        } else clearErrors('secondaryPhoneNumber');
                                                                                    }
                                                                                }}
                                                                                onKeyDown={(e) => {
                                                                                    preventPhoneInputKeys(e);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2} sm={2} md={1} xl={1}>
                                                                    <div
                                                                        style={{
                                                                            height: '100%',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <IconButton
                                                                            color="error"
                                                                            size="medium"
                                                                            onClick={() => {
                                                                                setShowSecondaryNumber(false);
                                                                                setValueinForm('secondaryPhoneNumber', '');
                                                                            }}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        )}

                                        <Grid item container>
                                            <Grid item xs={12}>
                                                <Typography variant="body1" className="label-500">
                                                    Email
                                                </Typography>
                                                <div style={{ display: 'flex', gap: '24px' }}>
                                                    <Grid item xs={12}>
                                                        {/* Primary Email */}
                                                        <Grid item xs={12}>
                                                            <Controller
                                                                name="primaryEmail"
                                                                control={control}
                                                                rules={{
                                                                    pattern: {
                                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                        message: 'Please enter a valid email address',
                                                                    },
                                                                }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        error={!!errors.primaryEmail}
                                                                        helperText={errors.primaryEmail ? errors.primaryEmail.message : ''}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <div
                                                                style={{
                                                                    height: '100%',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={primaryEmailIndex === 0}
                                                                            onChange={(e) => {
                                                                                showSecondaryEmail && setPrimaryEmailIndex(e.target.checked ? 0 : 1);
                                                                            }}
                                                                        />
                                                                    }
                                                                    label="Primary"
                                                                />
                                                            </div>
                                                        </Grid>
                                                    </Grid>

                                                    {/* Secondary Email */}
                                                    <Grid item xs={12}>
                                                        {showSecondaryEmail ? (
                                                            <>
                                                                <Grid item xs={12}>
                                                                    <Controller
                                                                        name="secondaryEmail"
                                                                        control={control}
                                                                        rules={{
                                                                            pattern: {
                                                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                                message: 'Please enter a valid email address',
                                                                            },
                                                                        }}
                                                                        render={({ field }) => (
                                                                            <TextField
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                error={!!errors.secondaryEmail}
                                                                                helperText={errors.secondaryEmail ? errors.secondaryEmail.message : ''}
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <div
                                                                        style={{
                                                                            height: '100%',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={primaryEmailIndex === 1}
                                                                                    onChange={(e) => {
                                                                                        setPrimaryEmailIndex(e.target.checked ? 1 : 0);
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label="Primary"
                                                                        />
                                                                        <IconButton
                                                                            color="error"
                                                                            size="medium"
                                                                            onClick={() => {
                                                                                setShowSecondaryEmail(false);
                                                                                setPrimaryEmailIndex(0);
                                                                            }}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                </Grid>
                                                            </>
                                                        ) : (
                                                            <div
                                                                onClick={() => setShowSecondaryEmail(true)}
                                                                style={{
                                                                    color: '#006CDD',
                                                                    cursor: 'pointer',
                                                                    fontWeight: 500,
                                                                    padding: '4px 5px',
                                                                    fontSize: '14px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                + ADD EMAIL
                                                            </div>
                                                        )}
                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Typography variant="body1" className="label-500">
                                                Website
                                            </Typography>
                                            <Controller
                                                name="website"
                                                control={control}
                                                rules={{
                                                    validate: (value) => (value ? /^https:\/\/.+$/.test(value) || 'Invalid URL' : true),
                                                }}
                                                render={({ field }) => (
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        error={!!errors.website}
                                                        helperText={errors.website ? errors.website.message : ''}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div style={{ display: editModalTabvalue == 1 ? 'block' : 'none' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <FormControl fullWidth error={!!errors.contactPrefrence}>
                                                <Stack spacing={1}>
                                                    <Typography
                                                        variant="body1"
                                                        style={{
                                                            fontWeight: 500,
                                                            fontSize: '16px',
                                                            lineHeight: '24px',
                                                            letterSpacing: '0.15px',
                                                        }}
                                                    >
                                                        Contact Preferences
                                                    </Typography>
                                                    <Controller
                                                        name="contactPreference"
                                                        control={control}
                                                        render={({ field: { onChange, value } }) => (
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                onChange={(e) => {
                                                                    onChange(e);
                                                                }}
                                                            >
                                                                {CONTACT_PREFRENCES_SUPPLERS.map((contact) => (
                                                                    <FormControlLabel
                                                                        style={{ marginRight: '26px' }}
                                                                        value={contact.key}
                                                                        control={<Radio />}
                                                                        label={contact?.value}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        )}
                                                    />
                                                    {errors.contactPreference && <FormHelperText>{errors.contactPreference.message}</FormHelperText>}
                                                </Stack>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={12} xl={12}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Street Address
                                                    {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                                        <span style={{ color: '#D32F2F' }}> *</span>
                                                    )}
                                                </Typography>
                                                <Controller
                                                    name="streetAddress"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.streetAddress}
                                                            helperText={errors.streetAddress ? errors.streetAddress.message : ''}
                                                            {...field}
                                                            onChange={(e) => {
                                                                setValueinForm('streetAddress', e.target.value);
                                                                setAddressValues({
                                                                    ...addressValues,
                                                                    streetAddress: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={4} xl={4}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    City
                                                    {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                                        <span style={{ color: '#D32F2F' }}> *</span>
                                                    )}
                                                </Typography>
                                                <Controller
                                                    name="city"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <AddressAutocomplete
                                                            list={cityList}
                                                            addressValues={addressValues}
                                                            value={getValues().city}
                                                            setAddressValue={setAddressValues}
                                                            type={'city'}
                                                            loader={cityListLoader}
                                                            setValue={setValueinForm}
                                                            error={!!errors.city}
                                                            clearInput={!addressValues.provinceId}
                                                        />
                                                    )}
                                                />
                                                {errors && errors.city && (
                                                    <p
                                                        style={{
                                                            color: '#d32f2f',
                                                            fontSize: '0.75rem',
                                                            letterSpacing: '0.03333em',
                                                            lineHeight: '1.66',
                                                            marginTop: '3px',
                                                        }}
                                                    >
                                                        {errors.city?.message}
                                                    </p>
                                                )}
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={4} xl={4}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontWeight: 500,
                                                        fontSize: '16px',
                                                        lineHeight: '24px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Province
                                                    {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                                        <span style={{ color: '#D32F2F' }}> *</span>
                                                    )}
                                                </Typography>
                                                <Controller
                                                    name="province"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <AddressAutocomplete
                                                            list={provinceList}
                                                            value={getValues().province}
                                                            addressValues={addressValues}
                                                            setAddressValue={setAddressValues}
                                                            type={'province'}
                                                            setCityList={setCityList}
                                                            fetchCityList={fetchCityList}
                                                            loader={provinceListLoader}
                                                            setValue={setValueinForm}
                                                            error={!!errors.province}
                                                        />
                                                    )}
                                                />
                                                {errors && errors.province && (
                                                    <p
                                                        style={{
                                                            color: '#d32f2f',
                                                            fontSize: '0.75rem',
                                                            letterSpacing: '0.03333em',
                                                            lineHeight: '1.66',
                                                            marginTop: '3px',
                                                        }}
                                                    >
                                                        {errors.province?.message}
                                                    </p>
                                                )}
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={4} xl={4}>
                                            <PostalCode
                                                name="postalCode"
                                                control={control}
                                                errors={errors}
                                                setValueinForm={setValueinForm}
                                                setAddressValue={setAddressValues}
                                                addressValues={addressValues}
                                                selectedCountry={selectedCountry}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>

                            <Grid item container justifyContent={'space-between'} style={{ marginTop: '24px' }} padding={'0px 24px 24px 24px'}>
                                <Grid item>
                                    <Stack spacing={2} direction="row">
                                        <Button variant="contained" color="error" onClick={() => setOpenDelete(true)} size="large">
                                            DELETE
                                        </Button>
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Stack spacing={2} direction="row">
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                handleCloseSupplier();
                                            }}
                                            size="large"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            type="submit"
                                            onClick={() => {
                                                if (Object.keys(errors)?.length != 0) {
                                                    setEditModalTabValue(0);
                                                }
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </form>
                    </Container>
                </Box>
            </Modal>
            <Snackbar
                open={openSuccessModal}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                message="I love snacks"
                key={'top' + 'center'}
                onClose={() => setOpenSuccessModal(false)}
                autoHideDuration={2000}
            >
                <Alert severity={'error'}>{successMessage}</Alert>
            </Snackbar>
        </div>
    );
}

export default SupplierEditModal;
